(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-graph-comparison"] && !Shopify.designMode) return;
  try {
    
  class GraphComparison {
    constructor(section) {
      this.section = section;
      this.selector = section.querySelector('[data-graph-selector]');
      this.graphs = section.querySelectorAll('[data-graph-id]');

      if (this.selector) {
        this.selector.addEventListener('change', this.handleChange.bind(this));
      }
    }

    handleChange(event) {
      const selectedId = event.target.value;

      this.graphs.forEach((graph) => {
        const graphId = graph.dataset.graphId;
        if (graphId === selectedId) {
          graph.classList.add('c-graph-comparison__graph--active');
        } else {
          graph.classList.remove('c-graph-comparison__graph--active');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.c-graph-comparison');
    sections.forEach((section) => new GraphComparison(section));

    // Remove skeleton loaders once visible images load
    document.querySelectorAll('.c-graph-comparison__graph-container--loading').forEach((container) => {
      const allImages = container.querySelectorAll('img');

      if (allImages.length === 0) {
        container.classList.remove('c-graph-comparison__graph-container--loading');
        return;
      }

      // Only wait for visible images (hidden ones with display:none won't fire load with lazy loading)
      const visibleImages = Array.from(allImages).filter((img) => {
        return img.offsetParent !== null || getComputedStyle(img).display !== 'none';
      });

      if (visibleImages.length === 0) {
        container.classList.remove('c-graph-comparison__graph-container--loading');
        return;
      }

      let loaded = 0;
      visibleImages.forEach((img) => {
        const onLoad = () => {
          loaded++;
          if (loaded >= visibleImages.length) {
            container.classList.remove('c-graph-comparison__graph-container--loading');
          }
        };

        if (img.complete && img.naturalWidth > 0) {
          onLoad();
        } else {
          img.addEventListener('load', onLoad, { once: true });
          img.addEventListener('error', onLoad, { once: true });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    var swiperEl = section.querySelector('.c-main-product__swiper');
    if (!swiperEl) return;

    var gallerySwiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    // Thumbnail click handling
    var thumbs = section.querySelectorAll('.c-main-product__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(this.getAttribute('data-thumb-index'), 10);
        gallerySwiper.slideTo(index);
      });
    });

    // Sync active thumbnail on slide change
    gallerySwiper.on('slideChange', function () {
      var activeIndex = gallerySwiper.activeIndex;
      thumbs.forEach(function (thumb) {
        var thumbIndex = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        thumb.classList.toggle('c-main-product__thumb--active', thumbIndex === activeIndex);
      });
    });

    // Detail Tabs functionality
    var detailTabs = section.querySelectorAll('[data-detail-tabs]');
    detailTabs.forEach(function (tabsContainer) {
      var tabs = tabsContainer.querySelectorAll('.c-detail-tabs__tab');
      var panels = tabsContainer.querySelectorAll('.c-detail-tabs__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetTab = this.getAttribute('data-tab');

          // Update tabs
          tabs.forEach(function (t) {
            t.classList.remove('c-detail-tabs__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('c-detail-tabs__tab--active');
          this.setAttribute('aria-selected', 'true');

          // Update panels
          panels.forEach(function (panel) {
            var panelId = panel.getAttribute('data-panel');
            if (panelId === targetTab) {
              panel.classList.add('c-detail-tabs__panel--active');
            } else {
              panel.classList.remove('c-detail-tabs__panel--active');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
